let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("h0uBE"), load("eBLgB"), load("1n8w9"), load("d0Fxy"), load("6NHX3"), load("77dzh")]).then(() => parcelRequire('nfKKY'));